exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.body[data-v-22da1801] {\n  /* height: calc(100vh - 10.5em);  */\n  display: flex;\n  align-items: stretch;\n}\n.chatMensagem[data-v-22da1801] {\n  display: flex;\n  flex: 1;\n  max-height: 81vh;\n  min-height: 81vh;\n}\n@media screen and (max-width: 1489px) {\n.body[data-v-22da1801] {\n    height: calc(100vh - 14.3em);\n}\n}\n@media screen and (max-width: 941px) {\n.body[data-v-22da1801] {\n    height: calc(100vh - 19.1em);\n}\n}\n", ""]);

// exports
